<template>
  <g>
    <path
      d="M11.1 12.0803C9.1 8.20025 10.18 4.72025 11.17 2.81025C11.36 2.45025 11.05 2.04025 10.64 2.09025C5.62 2.77025 1.78 7.16025 1.99 12.4103C2 12.4103 2 12.4103 2 12.4203C2.62 12.1503 3.29 12.0003 4 12.0003C5.66 12.0003 7.18 12.8303 8.1 14.1503C9.77 14.6303 11 16.1703 11 18.0003C11 19.5203 10.13 20.8303 8.88 21.5103C9.86 21.8303 10.91 22.0103 11.99 22.0103C15.12 22.0103 17.91 20.5703 19.75 18.3203C20.01 18.0003 19.79 17.5303 19.38 17.5003C16.89 17.3703 13.1 15.9703 11.1 12.0803Z"
    />
    <path
      d="M7 16.0002H6.82C6.4 14.8402 5.3 14.0002 4 14.0002C2.34 14.0002 1 15.3402 1 17.0002C1 18.6602 2.34 20.0002 4 20.0002C4.62 20.0002 6.49 20.0002 7 20.0002C8.1 20.0002 9 19.1002 9 18.0002C9 16.9002 8.1 16.0002 7 16.0002Z"
    />
  </g>
</template>
